export enum UserDeviceType {
  ANDROID = 'Android',
  IOS = 'IOS',
}

export enum UserDeviceStatus {
  ONLINE = 'Online',
  OFFLINE = 'Offline',
}
